<div class="container-fluid please-call-wrapper py-4 py-md-5">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-8">
      <div class="please-call-card-body text-center px-3 px-md-4">
    <!-- Phone Icon -->
    <div class="mb-2">
      <huk-icon name="mobile-phone" alttext="Phone support icon" size="4rem" colorpalette="dark"></huk-icon>
    </div>
 
    <!-- Main Heading -->
    <h1 class="text-body mb-3">{{ enumValue.TALK_TEXT_KEY }}</h1>
    
    <!-- Locked Account Message -->
    <div class="text-body fs-6 fw-normal mt-0 mb-4" *ngIf="rateLimitMessage">
          <p class="section-title text-body">{{ rateLimitMessage }}</p>
    </div>
 
    <!-- Error Message Alert (Token Expired) -->
    <huk-alert *ngIf="tokenExpired" colorpalette="danger">
      {{ enumValue.EXPIRED_INFO_TEXT }}
    </huk-alert>
 
    <!-- Having Trouble Section -->
    <div class="mb-4">
      <p class="fs-6 fw-bold text-body mb-1">{{ enumValue.LOGGING_TEXT_KEY }}</p>
      <div class="d-flex flex-column align-items-center">
        <p class="d-none d-sm-block fs-6 fw-normal text-body mb-0">Call {{ employeeNo }} weekdays 8a.m. - 8p.m. ET.</p>
        <huk-button id="contactHIGId" class="d-block d-sm-none mb-0" colorpalette="link" [expand]="false" [href]="'tel:' + employeeNo">Call {{ employeeNo }}</huk-button>
        <p class="d-block d-sm-none fs-6 fw-normal text-body mb-0">weekdays 8a.m. - 8p.m. ET.</p>
      </div>
    </div>
 
      <!-- Questions About Claims Section -->
      <div>
        <p class="fs-6 fw-bold text-body mb-1">{{ enumValue.CLAIMS_TEXT_KEY }}</p>
        <div class="d-flex flex-column align-items-center">
          <p class="d-none d-sm-block fs-6 fw-normal text-body mb-0">Call {{ employerNo }} weekdays 8a.m. - 8p.m. ET.</p>
          <huk-button id="contactsHIGId" class="d-block d-sm-none mb-0" colorpalette="link" [expand]="false" [href]="'tel:' + employerNo">Call {{ employerNo }}</huk-button>
          <p class="d-block d-sm-none fs-6 fw-normal text-body mb-0">weekdays 8a.m. - 8p.m. ET.</p>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>